import request from "../../h5-network/request.js";
import format from "cignacmb-date/src/format.js";

const AGAIN_STORAGE_KEY = "INSURANCE336_BIND_POLICY_AGAIN";
const AGAIN_FACE_LIMIT_STORAGE_KEY =
    "INSURANCE336_AGAIN_FACE_LIMIT_STORAGE_KEY";

export const again = {
    /**
   * 二次验证前，将需要的数据存进sessionStorage，以便二次验证通过后，使用这些数据
   * @param {*} data 
    {
      userName: "",
      mobileList: [],
      requestParams: {
        loading: true,
        url: "/xxx/xxxx",
        data: {
          idcard: "",
          phone: "",
          imgCode: "",
          smsCode: "",
          ucode: "", // 图形验证码唯一标识符
          tcode: "", // 图形验证码token
        },
        method: "POST"
      }
    }
   */
    setStorage(data) {
        window.sessionStorage.setItem(AGAIN_STORAGE_KEY, JSON.stringify(data));
    },
    getStorage({ success, fail }) {
        let result = null;

        try {
            result = JSON.parse(
                window.sessionStorage.getItem(AGAIN_STORAGE_KEY)
            );
        } catch (error) {
            if (typeof fail === "function") {
                fail(error);
            } else {
                throw error;
            }
        }

        success(result);
    },
    faceLimit: 5,
    setFaceNumStorage(ymd) {
        const userCode = window.localStorage.getItem("INSURANCE336_USRER_CODE");
        window.localStorage.setItem(
            AGAIN_FACE_LIMIT_STORAGE_KEY + "_" + userCode,
            JSON.stringify({
                ymd: ymd,
                num: again.getFaceNumStorage(ymd) + 1,
            })
        );
    },
    getFaceNumStorage(ymd) {
        const userCode = window.localStorage.getItem("INSURANCE336_USRER_CODE");
        const string = window.localStorage.getItem(
            AGAIN_FACE_LIMIT_STORAGE_KEY + "_" + userCode
        );

        if (string) {
            const object = JSON.parse(string);

            if (object.ymd === ymd) {
                return object.num;
            }
        }

        return 0;
    },
    enableFace() {
        return again.getFaceNumStorage(format(new Date())) < again.faceLimit;
    },
    goToFace({ from }) {
        again.getStorage({
            success: (result) => {
                const origin = location.origin;
                const url = origin + location.pathname + location.search;
                const successUrl = `${url}#/bind-policy-again/face-success?from=${from}`;
                const failUrl = `${url}#/bind-policy-again/face-fail?from=${from}`;

                request({
                    url: "/bdzb-core-service/member/startTxH5Face",
                    method: "POST",
                    data: {
                        // 使用+号拼接字符串，避免字符串内有换行符
                        callBack:
                            `${origin.replace(
                                "https:",
                                "http:"
                            )}/bdzb-core-service/member/faceCallBack?` +
                            `successUrl=${encodeURIComponent(successUrl)}&` +
                            `failUrl=${encodeURIComponent(failUrl)}`,
                        from: "browser",
                        tranxType: "BD",
                        name: result.userName,
                        idNo: result.requestParams.data.idcard,
                    },
                }).then((data) => {
                    // 请求成功，记录人脸识别次数
                    again.setFaceNumStorage(format(new Date()));
                    location.replace(data.respData.faceUrl);
                });
            },
        });
    },
};
